module.exports = __webpack_public_path__ + "static/features-bg-77d2ab68ea901a5bc063d41e1c385018.jpg";